<template>
  <div class="listar-assinaturas container">
    <div class="linha">
      <div class="select-documento">
        <label for="docs">Documento</label>
        <select
          class="form-control"
          id="docs"
          v-model="form.documento"
        >
          <option
            v-for="documento in documentos"
            :key="documento.id"
            :value="documento.id"
          >
            {{ documento.nome_exibicao }}
          </option>
        </select>
      </div>

      <div>
        <button
          class="btn btn-success"
          v-if="form.documento"
          @click="linkParaAssinatura()"
        >
          Link para assinatura
        </button>
      </div>
      <div>
        <button
          class="btn btn-warning"
          v-if="form.documento"
          @click="baixarAssinaturas()"
        >
          Baixar assinaturas
        </button>
      </div>
    </div>

    <div class="linha" v-if="form.documento">
      <datatable-panel
        class="datatable"
        :per-page="15"
        :url="cUrl"
        :fields="tableFields"
        no-data-template="Nenhum registro encontrado."
        ref="datatable"
      />
    </div>
  </div>
</template>

<script>
import DatatablePanel from 'metawesome-datatable'
import Utils from '@/mixins/utils.js';

export default {
  name: 'ListarAssinaturas',

  mixins: [
    Utils,
  ],

  components: {
    DatatablePanel,
  },

  data() {
    return {
      form: {
        documento: null
      },
      documentos: [],
      tableFields: [
        {
          name: 'nome',
          sortField: 'nome',
          title: 'Nome',
        },
        {
          name: 'cpf',
          sortField: 'cpf',
          title: 'CPF',
        },
        {
          name: 'created_at',
          sortField: 'created_at',
          title: 'Data de Assinatura',
          callback: data => {
            return this.formataData(data);
          },
        },
      ]
    };
  },

  mounted() {
    this.obterDocumentos();
  },

  methods: {
    async obterDocumentos() {
      try {
        this.$events.$emit('loading', true);
        const { data: response } = await this.$http.get('/documentos')
        this.documentos = response
      } catch (error) {
        this.customAlert(
          'Atenção!',
          'Não foi possível obter a lista de documentos.\n Entre em contato com um administrador.',
          'error'
        );
      }
      this.$events.$emit('loading', false);
    },

    linkParaAssinatura() {
      const doc = this.documentos.filter((item) => item.id == this.form.documento)[0]
      const nome_doc = doc.nome_exibicao;

      const idDocumentoEncriptado = this.CryptoJS.AES.encrypt((this.form.documento).toString(), this.$root.chaveFront).toString()

      let routeData = this.$router.resolve({ name: 'AssinarDocumento', params: { doc: idDocumentoEncriptado, nomeDoc: nome_doc } });

      window.open(routeData.href, '_blank');
    },

    formataData(data) {
      return this.$moment(data).format('DD/MM/YYYY - HH:mm');
    },

    async baixarAssinaturas() {
      try {
        window.open(`${this.$root.url}/documentos/download-assinaturas/${this.form.documento}`, '_blank');
      } catch (error) {
        this.customAlert(
          'Atenção!',
          'Não foi possível baixar a lista de documentos.\n Entre em contato com um administrador.',
          'error'
        );
      }
    },
  },

  computed: {
    cUrl() {
      return `${this.$root.url}/documentos/assinaturas?id_doc=${this.form.documento}&Key=${this.$root.chaveFront}`
    }
  }
}
</script>

<style lang="scss" scoped>
.listar-assinaturas {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  padding-top: 5vh;

  .linha {
    width: 100vw;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
  }

  .select-documento {
    min-width: 50%;
    max-width: 50%;
    padding-right: 10px;
  }

  .datatable {
    margin-top: 5vh;
    background-color: white;
    min-width: 80%;
    border: solid 1px rgb(209, 209, 209);
    box-shadow: 0px 0px 5px rgb(194, 194, 194);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/documentos/ListarAssinaturas.vue